import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const providerFareApiRoutes = {
    list: apiDataManagerBaseURL + "providerfares",
};

export class ProviderFareAPI {
    static list(provider = '') {
        return API.authenticatedRequest({
            url: provider === '' ? providerFareApiRoutes.list : `${providerFareApiRoutes.list}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}
